import { Layout, FetchPtData as FetchPtDataComponent } from "components"
export const FetchPtData = () => {
 return (
  <Layout>
   <FetchPtDataComponent />
  </Layout>
 )
}
